import React from 'react';
import { Helmet } from 'react-helmet-async';
import {
  SITE_NAME,
  SITE_URL,
  DEFAULT_SEO_DESCRIPTION,
  DEFAULT_SEO_KEYWORDS,
} from '../siteConfig';

const SEO = ({
  title,
  description,
  keywords,
  ogImage,
  ogType = 'website',
  canonicalUrl,
  noIndex = false,
}) => {
  const fullTitle = title ? `${title} | ${SITE_NAME}` : SITE_NAME;
  const defaultImage = '/images/og-image.jpg';

  return (
    <Helmet>
      <title>{fullTitle}</title>
      <meta name="description" content={description || DEFAULT_SEO_DESCRIPTION} />
      <meta name="keywords" content={keywords || DEFAULT_SEO_KEYWORDS} />
      <meta name="author" content={SITE_NAME} />

      {canonicalUrl && <link rel="canonical" href={canonicalUrl} />}

      {noIndex ? (
        <meta name="robots" content="noindex, nofollow" />
      ) : (
        <meta name="robots" content="index, follow" />
      )}

      <meta property="og:type" content={ogType} />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={description || DEFAULT_SEO_DESCRIPTION} />
      <meta property="og:image" content={ogImage?.startsWith('http') ? ogImage : `${SITE_URL}${ogImage || defaultImage}`} />
      <meta property="og:url" content={canonicalUrl || SITE_URL} />
      <meta property="og:site_name" content={SITE_NAME} />
      <meta property="og:locale" content="en_US" />

      <meta property="twitter:card" content="summary_large_image" />
      <meta property="twitter:title" content={fullTitle} />
      <meta property="twitter:description" content={description || DEFAULT_SEO_DESCRIPTION} />
      <meta
        property="twitter:image"
        content={ogImage?.startsWith('http') ? ogImage : `${SITE_URL}${ogImage || defaultImage}`}
      />

      <meta name="viewport" content="width=device-width, initial-scale=1" />
      <meta name="theme-color" content="#1a365d" />
      <meta name="msapplication-TileColor" content="#1a365d" />

      <script type="application/ld+json">
        {JSON.stringify({
          '@context': 'https://schema.org',
          '@type': 'MedicalClinic',
          name: SITE_NAME,
          description: description || DEFAULT_SEO_DESCRIPTION,
          url: SITE_URL,
          logo: `${SITE_URL}/logo.jpg`,
          image: `${SITE_URL}${ogImage || defaultImage}`,
          medicalSpecialty: 'Telehealth',
          priceRange: '$25–$50',
        })}
      </script>
    </Helmet>
  );
};

export default SEO;
